import {atom} from "jotai";
import {Field} from "../types/domain/field";

export const activeMergedFarmItems = atom<Field[]>([]);

activeMergedFarmItems.debugLabel = "activeMergedFarmItems";
